module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-list"
  }, [_c('span', {
    staticClass: "panel-list__name"
  }, [_vm._v(_vm._s(_vm.listGroup.model.name))]), _vm._v(" "), _c('div', {
    staticClass: "panel-list__items-wrap"
  }, [(_vm.scrollable) ? [_c('virtual-list', {
    ref: "virtualList",
    attrs: {
      "is-pinned": true,
      "size": 42,
      "remain": 12,
      "data-source": _vm.listGroup.children
    }
  }, _vm._l((_vm.listGroup.children), function(item) {
    return _c('panel-item', {
      key: item.model.id,
      ref: "item",
      refInFor: true,
      attrs: {
        "is-selected": _vm.currentSelectedItem == item,
        "name": item.model.name,
        "description": item.model.description,
        "is-locked": _vm.locked,
        "has-children": item.hasChildren()
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectItem(item, $event)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.model.name)
      }
    })])
  }), 1)] : _vm._l((_vm.listGroup.children), function(item) {
    return _c('panel-item', {
      key: item.model.id,
      ref: "item",
      refInFor: true,
      attrs: {
        "is-selected": _vm.currentSelectedItem == item,
        "name": item.model.name,
        "description": item.model.description,
        "path": item.model.path,
        "is-locked": _vm.locked,
        "has-children": item.hasChildren()
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectItem(item, $event)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.model.name)
      }
    })])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e8ab6ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/attributePanel/components/List.vue
// module id = 1807
// module chunks = 0